<template>
  <div
    aria-hidden="true"
    class="fixed inset-0 z-50 cursor-default flex items-center justify-center bg-[#000000]/20"
  >
    <slot />
  </div>
</template>
